module.exports = __webpack_public_path__ + "static/media/game-results-icon.2a467092.svg";